import { selectCheckedDriver, addDriverFinger, delDriverFinger, clearDriverFinger, selectDriverFingerList, selectDriverFinger, deleteByDriverNum, selectAllFingerByCar, IssueFingerToCarList, selectFingerList, DriverFingerprint, insertDriverFinger, deleteDriverFinger, FingerprintLibraryList, insertFingerprintLibrary, updateFingerprintLibrary, deleteFingerprintLibrary, transferFingerprintLibrary, selectPrintLibraryList } from "../../api/config/modules/DriverFingerprintFile";

const state = {
    DriverFingerprint: {},
    insertDriverFinger: {},
    deleteDriverFinger: {},
    FingerprintLibraryList: {},
    insertFingerprintLibrary: {},
    updateFingerprintLibrary: {},
    deleteFingerprintLibrary: {},
    transferFingerprintLibrary: {},
    selectPrintLibraryList: {},
    selectFingerList: {},
    IssueFingerToCarList: {},
    selectAllFingerByCar: {},
    deleteByDriverNum: {},
    selectDriverFinger: {},
    selectDriverFingerList: {},
    clearDriverFinger: {},
    delDriverFinger: {},
    addDriverFinger: {},
    selectCheckedDriver: {}
};

const mutations = {
    SET_DRIVERFINGERPRINT: (state, DriverFingerprint) => {
        state.DriverFingerprint = DriverFingerprint;
    },
    SET_INSERTDRIVERFINGER: (state, insertDriverFinger) => {
        state.insertDriverFinger = insertDriverFinger;
    },
    SET_DELETEDRIVERFINGER: (state, deleteDriverFinger) => {
        state.deleteDriverFinger = deleteDriverFinger;
    },
    SET_FINGERPRINTLIBRARYLIST: (state, FingerprintLibraryList) => {
        state.FingerprintLibraryList = FingerprintLibraryList;
    },
    SET_INSERTFINGERPRINTLIBRARY: (state, insertFingerprintLibrary) => {
        state.insertFingerprintLibrary = insertFingerprintLibrary;
    },
    SET_UPDATEFINGERPRINTLIBRARY: (state, updateFingerprintLibrary) => {
        state.updateFingerprintLibrary = updateFingerprintLibrary;
    },
    SET_DELETEFINGERPRINTLIBRARY: (state, deleteFingerprintLibrary) => {
        state.deleteFingerprintLibrary = deleteFingerprintLibrary;
    },
    SET_TRANSFERFINGERPRINTLIBRARY: (state, transferFingerprintLibrary) => {
        state.transferFingerprintLibrary = transferFingerprintLibrary;
    },
    SET_SELECTPRINTLIBRARYLIST: (state, selectPrintLibraryList) => {
        state.selectPrintLibraryList = selectPrintLibraryList;
    },
    SET_SELECTFINGERLIST: (state, selectFingerList) => {
        state.selectFingerList = selectFingerList;
    },
    SET_ISSUEFINGERTOCARLIST: (state, IssueFingerToCarList) => {
        state.IssueFingerToCarList = IssueFingerToCarList;
    },
    SET_SELECTALLFINGERBYCAR: (state, selectAllFingerByCar) => {
        state.selectAllFingerByCar = selectAllFingerByCar;
    },
    SET_DELETEBYDRIVERNUM: (state, deleteByDriverNum) => {
        state.deleteByDriverNum = deleteByDriverNum;
    },
    SET_SELECTDRIVERFINGER: (state, selectDriverFinger) => {
        state.selectDriverFinger = selectDriverFinger;
    },
    SET_SELECTDRIVERFINGERLIST: (state, selectDriverFingerList) => {
        state.selectDriverFingerList = selectDriverFingerList;
    },
    SET_CLEARDRIVERFINGER: (state, clearDriverFinger) => {
        state.clearDriverFinger = clearDriverFinger;
    },
    SET_DELDRIVERFINGER: (state, delDriverFinger) => {
        state.delDriverFinger = delDriverFinger;
    },
    SET_ADDDRIVERFINGER: (state, addDriverFinger) => {
        state.addDriverFinger = addDriverFinger;
    },
    SET_SELECTCHECKEDDRIVER: (state, selectCheckedDriver) => {
        state.selectCheckedDriver = selectCheckedDriver;
    },
};

const actions = {
    GET_DRIVERFINGERPRINT: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            DriverFingerprint(data)
                .then((res) => {
                    commit("SET_DRIVERFINGERPRINT", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_INSERTDRIVERFINGER: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            insertDriverFinger(data)
                .then((res) => {
                    commit("SET_INSERTDRIVERFINGER", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_DELETEDRIVERFINGER: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            deleteDriverFinger(data)
                .then((res) => {
                    commit("SET_DELETEDRIVERFINGER", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_FINGERPRINTLIBRARYLIST: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            FingerprintLibraryList(data)
                .then((res) => {
                    commit("SET_FINGERPRINTLIBRARYLIST", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_INSERTFINGERPRINTLIBRARY: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            insertFingerprintLibrary(data)
                .then((res) => {
                    commit("SET_INSERTFINGERPRINTLIBRARY", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_UPDATEFINGERPRINTLIBRARY: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            updateFingerprintLibrary(data)
                .then((res) => {
                    commit("SET_UPDATEFINGERPRINTLIBRARY", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_DELETEFINGERPRINTLIBRARY: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            deleteFingerprintLibrary(data)
                .then((res) => {
                    commit("SET_DELETEFINGERPRINTLIBRARY", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_TRANSFERFINGERPRINTLIBRARY: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            transferFingerprintLibrary(data)
                .then((res) => {
                    commit("SET_TRANSFERFINGERPRINTLIBRARY", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_SELECTPRINTLIBRARYLIST: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            selectPrintLibraryList(data)
                .then((res) => {
                    commit("SET_SELECTPRINTLIBRARYLIST", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_SELECTFINGERLIST: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            selectFingerList(data)
                .then((res) => {
                    commit("SET_SELECTFINGERLIST", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_ISSUEFINGERTOCARLIST: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            IssueFingerToCarList(data)
                .then((res) => {
                    commit("SET_ISSUEFINGERTOCARLIST", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_SELECTALLFINGERBYCAR: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            selectAllFingerByCar(data)
                .then((res) => {
                    commit("SET_SELECTALLFINGERBYCAR", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_DELETEBYDRIVERNUM: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            deleteByDriverNum(data)
                .then((res) => {
                    commit("SET_DELETEBYDRIVERNUM", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_SELECTDRIVERFINGER: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            selectDriverFinger(data)
                .then((res) => {
                    commit("SET_SELECTDRIVERFINGER", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_SELECTDRIVERFINGERLIST: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            selectDriverFingerList(data)
                .then((res) => {
                    commit("SET_SELECTDRIVERFINGERLIST", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_CLEARDRIVERFINGER: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            clearDriverFinger(data)
                .then((res) => {
                    commit("SET_CLEARDRIVERFINGER", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_DELDRIVERFINGER: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            delDriverFinger(data)
                .then((res) => {
                    commit("SET_DELDRIVERFINGER", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_ADDDRIVERFINGER: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            addDriverFinger(data)
                .then((res) => {
                    commit("SET_ADDDRIVERFINGER", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_SELECTCHECKEDDRIVER: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            selectCheckedDriver(data)
                .then((res) => {
                    commit("SET_SELECTCHECKEDDRIVER", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
